var _a;
import createDiceRoller from './createDiceRoller';
export { default as createDiceRoller } from './createDiceRoller';
export { default as withPlugins } from './withPlugins';
export { default as random } from './util/random';
export var tokenize = (_a = createDiceRoller(), _a.tokenize), tokenizeFaultTolerant = _a.tokenizeFaultTolerant, calculateFinalResult = _a.calculateFinalResult, rollDice = _a.rollDice, tallyRolls = _a.tallyRolls, roll = _a.roll;
